module.exports = __webpack_public_path__ + "img/ltksalealert-2x.811716f.jpg";